export enum VoorkeurenNotificaties {
  /// <summary>
  /// Geen notificaties
  /// </summary>
  Geen = 0,
  /// <summary>
  /// Wel notificaties
  /// </summary>
  Dagelijks = 1,
}
